import React, { useState, useEffect } from "react";
import { Circle } from "@react-google-maps/api";

const AnimatedCircle = ({ orderData, radius }) => {
  const [opacity, setOpacity] = useState(0.2);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity((prevOpacity) => (prevOpacity === 0.2 ? 0.3 : 0.2));
    }, 1000); // Change the radius and opacity every second

    return () => clearInterval(interval);
  }, []);

  return (
    <Circle
      center={{
        lat: orderData?.geo?.coordinates?.[0],
        lng: orderData?.geo?.coordinates?.[1],
      }}
      radius={radius}
      options={{
        fillColor: "blue",
        fillOpacity: opacity,
        strokeColor: "blue",
        strokeOpacity: 0.5,
        strokeWeight: 1,
      }}
    />
  );
};

export default AnimatedCircle;
